import React from 'react';
import { 
  HelpCircle, 
  Heart, 
  Activity, 
  Clock, 
  Zap, 
  Shield, 
  Smartphone 
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по тренировкам с контролем пульса
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Heart,
      title: 'Измерение пульса в покое',
      description: 'Измеряйте пульс утром после пробуждения или после 10 минут полного расслабления.'
    },
    {
      icon: Activity,
      title: 'Постепенное увеличение',
      description: 'Начинайте с нижней границы целевой зоны и постепенно увеличивайте интенсивность.'
    },
    {
      icon: Clock,
      title: 'Длительность тренировки',
      description: 'Для эффективности необходимо 20-40 минут непрерывной работы в целевой зоне пульса.'
    },
    {
      icon: Zap,
      title: 'Частота тренировок',
      description: 'Для заметных результатов тренируйтесь 3-5 раз в неделю с достаточным восстановлением.'
    },
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'При головокружении, боли в груди или сильной одышке немедленно снизьте интенсивность.'
    },
    {
      icon: Smartphone,
      title: 'Пульсометры',
      description: 'Используйте нагрудные датчики для большей точности, чем датчики на запястье.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-red-500" />
        Советы по тренировкам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Shield className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-red-700 dark:text-red-300 mb-2">
              Предупреждение
            </h4>
            <p className="text-xs text-red-600 dark:text-red-400 mb-3">
              Перед началом любой программы тренировок обязательно проконсультируйтесь с врачом, особенно если у вас есть хронические заболевания или вы старше 40 лет.
            </p>
            <a 
              href="#" 
              className="block w-full py-1.5 text-xs text-center bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
              onClick={(e) => {
                e.preventDefault();
                alert('Уточните у своего врача или фитнес-тренера оптимальный диапазон пульса для ваших индивидуальных целей и состояния здоровья.');
              }}
            >
              Подробнее о безопасности
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;